import ProfileRepositoryImpl from 'frontcore/domain/profile/model/ProfileRepository'
import ProfileRequester from 'frontcore/domain/profile/model/ProfileRequester'
import { ProfileAPIClientFactory } from 'frontcore/domain/profile/api/factory'
import {
  ProfileRepository,
  UserProfile,
} from 'frontcore/domain/profile/model/Profile.d'

export class ProfileRepositoryFactory {
  static build (profile: UserProfile): ProfileRepository {
    return new ProfileRepositoryImpl(profile)
  }
}

export class ProfileRequesterFactory {
  static build (): ProfileRequester {
    return new ProfileRequester(
      ProfileAPIClientFactory.build()
    )
  }
}
